import { Button } from '@ethings/ui-toolkit';
import { FC } from 'react';
import { useHref } from 'react-router-dom';
import { Display } from '../../types';
import { testid } from '../../util/test-id';
import { LinkData } from './static-data.types';

interface LinkButtonProps {
  'data-testid'?: string;
  link?: LinkData;
}

interface MediaViewButtonProps extends Display {
  onClick: () => void;
}

export const LinkButton: FC<LinkButtonProps> = ({ link, ...props }) => {
  const href = useHref(link?.url ?? '');

  if (!link) return <></>;

  return (
    <Button
      data-testid={props['data-testid'] ?? 'link-button'}
      href={href}
      variant="text"
    >
      {link.display}
    </Button>
  );
};

export const MediaViewButton: FC<MediaViewButtonProps> = ({ display, onClick }) => {
  return (
    <Button
      data-testid={testid`action-button-${display}`}
      onClick={onClick}
      variant="text"
    >
      {display}
    </Button>
  );
};
